import facialAntiAgingQuestions, { FacialAntiAgingQuestionFieldAnswers } from './initial/questions';

const FacialAntiAgingQuestions = [...facialAntiAgingQuestions];
export default FacialAntiAgingQuestions;

export type { FacialAntiAgingQuestionFieldAnswers };
